/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Slot_GalleryInputs */

const cs_builder_slot_gallery = /** @type {(inputs: Builder_Slot_GalleryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Galerie`)
};

const en_builder_slot_gallery = /** @type {(inputs: Builder_Slot_GalleryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gallery`)
};

/**
* | output |
* | --- |
* | "Gallery" |
*
* @param {Builder_Slot_GalleryInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_slot_gallery = /** @type {((inputs?: Builder_Slot_GalleryInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Slot_GalleryInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_slot_gallery(inputs)
	return cs_builder_slot_gallery(inputs)
});